<div class="container-fluid">

    <div class="row">

        <div class="col-lg-6 col-md-4 d-lg-block d-md-block d-sm-none d-none">
            <img src="assets/images/contact-sales-new.jpg" class="img-fluid" alt="image">
        </div>

        <div class="col-lg-6 col-md-8 mb-lg-5 mb-md-5 ">

            <div class="card">

                <div class="card-header">

                    <div class="card-header-label">
                        <span> Contact Sales </span>
                    </div>
                </div>

                <div class="card-body">

                    <div class="row">

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3">

                            <label class="form-label"> First Name </label>
                            <input type="text" placeholder="First Name" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.firstName">
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3">

                            <label class="form-label"> Last Name </label>
                            <input type="text" placeholder="Last Name" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.lastName">
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 pb-lg-3 pb-lg-3">

                            <label class="form-label"> Work Email Address </label>
                            <input type="email" placeholder="Work Email" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.email">
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3">

                            <label class="form-label"> Phone Number </label>
                            <input type="number" placeholder="Phone Number" class="form-control"
                                [ngModel]="viewModel.singleContactSales.contactNumber">
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3">

                            <label class="form-label"> Are you ? </label>
                            <select class="form-control" (change)="selected($event)"
                                [(ngModel)]="viewModel.singleContactSales.select">
                                <option value=""> --Select one-- </option>
                                <option value="individual"> Individual </option>
                                <option value="company"> Company </option>
                            </select>
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3" *ngIf="viewModel.showCompanyInfo">

                            <label class="form-label"> Company Name </label>
                            <input type="text" placeholder="Company Name" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.companyName">
                        </div>

                        <div class="col-lg-6 col-md-6 col-sm-6 col-6 pb-lg-3" *ngIf="viewModel.showCompanyInfo">

                            <label class="form-label"> Company Size </label>
                            <input type="number" placeholder="Company Size" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.companySize">
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-12 pb-lg-3">

                            <label class="form-label"> Please Select any one of your Requirement </label>

                            <select class="form-control" [(ngModel)]="viewModel.singleContactSales.product">
                                <option value=""> --Select one-- </option>
                                <option value="product"> Purchase Our Product </option>
                                <option value="subscription"> What are our Subscriptions? </option>
                            </select>
                        </div>

                        <div class="col-lg-12 col-md-12 col-sm-12 col-12">

                            <label class="form-label"> Message </label>
                            <textarea rows="5" placeholder="Message" class="form-control"
                                [(ngModel)]="viewModel.singleContactSales.contactMessage">
                            </textarea>
                        </div>

                        <div class="form-check mt-lg-2">

                            <input type="checkbox" class="form-check-input me-2" value="" />
                            <label class="form-check-label">
                                <small>
                                    I accept Terms & Condition of Security Related
                                </small>
                            </label>
                        </div>

                        <div class="text-center text-lg-center mt-4 pt-2">
                            <button type="button" class="btn btnSubmit" (click)="contactSalesForm()"> Submit </button>
                        </div>

                    </div>

                </div>

            </div>

        </div>

    </div>